import { cashierUrl } from 'endpoints';
import { fetch } from '@nackle/umbrella';

export function getAccountBalance( accessToken, externalId, companyId ) {
    return fetch( `${ cashierUrl }/account/external/${ externalId }/point-balance`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${ accessToken }`,
            'company-id': companyId
        }
    } ).then( response => response.json() );
}

export function getAccountInfo( accessToken, externalId, companyId ) {
    return fetch( `${ cashierUrl }/account/external/${ externalId }/account-info`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${ accessToken }`,
            'company-id': companyId
        }
    } ).then( response => response.json() );
}

export function getMarketplaceUrl( accessToken, person, companyId, landing ) {
    return fetch( `${ cashierUrl }/account/id/${ person.id }/catalog-sso`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${ accessToken }`,
            'company-id': companyId
        },
        body: JSON.stringify( {
            landingPage: landing,
            country: person.country
        } )
    } ).then( response => response.json() );
}